module.exports = __webpack_public_path__ + "static/3-14798f5329ac5979b57e840942d6ed42.png";